import { render } from "./DeletedStatusSelect.vue?vue&type=template&id=4d00b225"
import script from "./DeletedStatusSelect.vue?vue&type=script&lang=js"
export * from "./DeletedStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__